export const BE_TURNSTILE_TOKEN_NAME = 'turnstileToken';

const WIDGET_DEV_1_KEY = '0x4AAAAAABgnlBz83RjqFbqR';
const WIDGET_PROD_1_KEY = '0x4AAAAAABgnyMs1otzyQX5B';
const WIDGET_PROD_2_KEY = '0x4AAAAAABgnydbWugkFafO_';

export const SITE_WIDGETS = [
  {
    key: WIDGET_DEV_1_KEY,
    domains: ['twbox.io', 'twtest.io'],
  },
  {
    key: WIDGET_PROD_1_KEY,
    domains: [
      'treatwell.at',
      'treatwell.be',
      'treatwell.de',
      'treatwell.es',
      'treatwell.fr',
      'treatwell.gr',
      'treatwell.ie',
      'treatwell.it',
      'treatwell.lt',
      'treatwell.nl',
    ],
  },
  {
    key: WIDGET_PROD_2_KEY,
    domains: [
      'treatwell.ch',
      'treatwell.co.uk',
      'treatwell.dk',
      'treatwell.lv',
      'treatwell.pt',
    ],
  },
];

export function getSitekey(domain: string): string | null {
  const widget = SITE_WIDGETS.find(({ domains }) =>
    domains.find(widgetDomain => domain.endsWith(widgetDomain)),
  );
  return widget ? widget.key : null;
}
